import React from "react";
import Tata from "../Artifacts/DealerLogo.svg";
import Logout from "../Artifacts/logout.png";

import { Link } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { useQuery } from "@tanstack/react-query";
import { axInst } from "./Login/Service";

const fetchUpdatedTime = async (body) => {
  if (
    body.dashboardAlias === "dealer_invoice" ||
    body.dashboardAlias === "dealer_offtake" ||
    body.dashboardAlias === "dealer_retail_pipeline" ||
    body.dashboardAlias === "dealer_stocks" ||
    body.dashboardAlias === "dealer_lead" ||
    body.dashboardAlias === "dealer_complaint" ||
    body.dashboardAlias === "dealer_sales_service_center" ||
    body.dashboardAlias === "dealer_review_dashboard"
  ) {
    try {
      const res = await axInst.post("dashboard-updated_time", body);
      return res.data.last_updated_time;
    } catch (error) {
      console.error(error);
      return null;
    }
  } else {
    return null;
  }
};

export const Header = ({
  title,
  handleLogout,
  setMobileOpen,
  dashboardAlias,
}) => {
  const {
    data: dailyhour,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["time", title],
    queryFn: () => fetchUpdatedTime({ dashboardAlias }),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  return (
    <>
      <div className="bg-[#2A5775] border h-[3.5rem] grid lg:block md:block text-white">
        <header className="grid grid-cols-3">
          <section className="self-center hidden px-3 py-2 lg:col-start-1 md:col-start-1 md:block lg:block">
            <img
              src={Tata}
              width="260"
              height="42"
              alt="Tata Motors"
              loading="eager"
              className="w-[260px] h-[42px]"
            />
          </section>

          <div className="self-center leading-3 text-center justify-self-start md:hidden lg:hidden pl-3">
            <GiHamburgerMenu
              size={26}
              className="cursor-pointer"
              onClick={() => setMobileOpen(true)}
            />
          </div>

          <div className="self-center text-xl font-bold text-center justify-self-center md:text-base lg:text-2xl whitespace-nowrap">
            <span className="md:text-xl text-base">{title}</span>
          </div>

          <section className="self-center px-2 gap-6 py-0.5 justify-self-end lg:flex md:flex ">
            {dailyhour && !isFetching && !isError && (
              <div className="text-xs md:block hidden">
                Last Updated on:
                <span className="block text-[10px]">{dailyhour}</span>
              </div>
            )}

            <Link onClick={handleLogout} title="Logout">
              <img
                src={Logout}
                width="24"
                height="24"
                alt="Logout"
                fetchpriority="high"
                className="w-6 lg:w-7 md:w-7 "
              />
            </Link>
          </section>
        </header>
      </div>
      {dailyhour && !isFetching && !isError && (
        <div className="text-xs md:hidden text-[10px] block text-center mt-1">
          Last Updated on:
          {dailyhour}
        </div>
      )}
    </>
  );
};
